import { useEffect } from "react";

import { useTranslation } from "lib/i18n/use-translation";

import BookmarkLg from "assets/icons/bookmark-lg.svg?react";
import css from "./bookmark-notification.module.scss";

type NotificationType = "added" | "deleted";

interface BookmarkNotificationProps {
  type: NotificationType;
  onClose: () => void;
}

export function BookmarkNotification({
  type,
  onClose,
}: BookmarkNotificationProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(onClose, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const message =
    type === "added" ? t("Добавлено в закладки") : t("Удалено из закладок");

  return (
    <div className={css.overlay}>
      <div className={css.content}>
        <div className={css.icon}>
          <BookmarkLg width={240} height={288} />
        </div>
        <div className={css.text}>{message}</div>
      </div>
    </div>
  );
}
